<template>
  <transition name="toast">
    <div class="toast" v-show="show" :class="[type, customClass]">
      <div class="icon" v-if="type">
        <i
          class="dd-iconfont icon-jieshi-iconcopy21"
          v-if="type == 'success'"
        ></i>
        <i
          class="dd-iconfont icon-jieshi-iconcopy21"
          v-if="type == 'error'"
        ></i>
        <i
          class="dd-iconfont icon-jieshi-iconcopy21"
          v-if="type == 'loading'"
        ></i>
      </div>
      <div class="message" v-if="!dangerouslyUseHTMLString">{{ message }}</div>
      <div class="message" v-else v-html="message"></div>
    </div>
  </transition>
</template>

<script>
/* eslint-disable */
export default {
  data() {
    return {
      type: '',
      message: '',
      show: false,
      customClass: '',
      dangerouslyUseHTMLString: false,
    };
  },
};
</script>

<style lang="scss" scoped>
.toast {
  min-width: 80px;
  background-color: rgba(0, 0, 0, 0.8);
  position: fixed;
  top: 50%;
  left: 50%;
  border-radius: 5px;
  transform: translate(-50%, -50%);
  display: flex;
  flex-direction: column;
  z-index: 999;
  min-height: 40px;
  line-height: 20px;
  padding: 10px 20px;
}
.icon {
  text-align: center;
  color: #fff;
  margin: 20px 0 24px;
}
.dd-iconfont {
  font-size: 60px;
}
.message {
  font-size: 14px;
  color: #fff;
  text-align: center;
  font-weight: 400;
}
.success,
.error,
.loading {
  padding: 22px 48px 42px;
}
</style>